import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "smart-right",
  "use": "smart-right-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"smart-right\"><g transform=\"translate(1 1)\" stroke=\"#62B929\" fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#EEFFE2\" cx=\"7.5\" cy=\"7.5\" r=\"8\" /><path stroke-width=\"1.5\" stroke-linecap=\"square\" d=\"M11 6l-4.5 4.5L4 8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id